import * as ko from "knockout";
import entityBase from "entityBase";

export class request_unit extends entityBase {
  model_id: KnockoutObservable<string>;
  part_id: KnockoutObservable<string>;
  quantity: KnockoutObservable<number>;
  request_id: KnockoutObservable<string>;
  request_line: KnockoutObservable<number>;
  request_unit_id: KnockoutObservable<string>;
  serial_id: KnockoutObservable<string>;

  constructor(item: any) {
    super();
    this.model_id = ko.observable(item?.model_id).extend({ maxLength: 128 });
    this.part_id = ko.observable(item?.part_id).extend({ maxLength: 50 });
    this.quantity = ko.observable(item?.quantity);
    this.request_id = ko.observable(item?.request_id).extend({ maxLength: 32 });
    this.request_line = ko.observable(item?.request_line);
    this.request_unit_id = ko.observable(item?.request_unit_id).extend({ maxLength: 32 });
    this.serial_id = ko.observable(item?.serial_id).extend({ maxLength: 50 });
  }
}
